import { Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { BILLING_ENABLED } from '@constants/features';

/**
 * Checks whether an API error is a billing-related block
 * (unpaid subscription or insufficient credit) and, if so, shows a
 * persistent notification pointing the user to the right billing page.
 *
 * Returns true when the error was handled (caller should stop further
 * error handling), false otherwise.
 */
export function handleCreditBlockError(error: any): boolean {
  const errorCode = error?.response?.data?.error?.code;
  const httpStatus = error?.response?.status;
  const errorMessage = error?.response?.data?.error?.message || error?.response?.data?.message || error?.message || '';

  // Unpaid subscription block. Must be checked BEFORE insufficient credit
  // because both may share the same HTTP status.
  const isAccountUnpaid =
    errorCode === 'ACCOUNT_UNPAID' || errorMessage.toLowerCase().includes('subscription renewal is unpaid');

  if (isAccountUnpaid) {
    notifications.show({
      title: 'Langganan Belum Dibayar',
      message: (
        <div>
          <p>Langganan Anda belum dibayar untuk periode ini. Layanan diblokir sampai tagihan dilunasi.</p>
          {BILLING_ENABLED && (
            <Button
              component="a"
              href="/subscription"
              target="_blank"
              rel="noopener noreferrer"
              variant="light"
              size="xs"
              mt="xs"
            >
              Bayar Sekarang
            </Button>
          )}
        </div>
      ),
      color: 'red',
      autoClose: false,
      withCloseButton: true,
    });
    return true;
  }

  // Insufficient credit: structured error code or HTTP status first,
  // fallback to string matching.
  const isInsufficientCredit =
    errorCode === 'INSUFFICIENT_CREDIT' ||
    httpStatus === 402 ||
    errorMessage.toLowerCase().includes('insufficient credit');

  if (isInsufficientCredit) {
    notifications.show({
      title: 'Saldo Kredit Tidak Cukup',
      message: (
        <div>
          <p>{errorMessage || 'Saldo kredit Anda tidak mencukupi untuk melakukan submit.'}</p>
          {BILLING_ENABLED && (
            <Button
              component="a"
              href="/credit/topup"
              target="_blank"
              rel="noopener noreferrer"
              variant="light"
              size="xs"
              mt="xs"
            >
              Top Up Kredit
            </Button>
          )}
        </div>
      ),
      color: 'red',
      autoClose: false,
      withCloseButton: true,
    });
    return true;
  }

  return false;
}
